
import * as Configuration from '../../../../app.constants.js';

export class MessageConditionService {
  constructor($http) {
    this._$http = $http;
  }

  listPublicPosts(companyId, siteId) {
    return this._$http.get(
      Configuration.constants.baseUrl + 'api/1.0/companies/'+companyId+'/sites/'+ siteId +'/public-posts/',
      {params: {fields : 'id,content,external_url,created_time,created_time_int'}});
  }

  static MessageConditionFactory($http) {
    return new MessageConditionService($http);
  }
}
MessageConditionService.MessageConditionFactory.$inject = ['$http'];
